import type { Dispatch } from 'redux';
import {
    createActionFactoryForFeature,
    createActionFactory,
    contactsLeftNavItemId,
    favoritesLeftNavItemId,
    Feature,
    createThunk,
    ThunkDispatch,
} from '../../../shared';
import { getAppState, serializeAndPersistPeopleHubOptions } from '../../../appstate';
import { menuItemClicked } from '../../../appchrome/actions/user/leftNavActions';
const actionFactory = createActionFactoryForFeature(Feature.CommandBar);

export const deletePersonasClickedAction = actionFactory<void>('DeletePersonasClickedAction');
export const contactCleanupMenuItemClickedAction = actionFactory<void>(
    'ContactCleanupMenuItemClickedAction'
);
export const exportContactsMenuItemClickedAction = actionFactory<void>(
    'ExportContactsMenuItemClickedAction'
);
export const importContactsMenuItemClickedAction = actionFactory<void>(
    'ImportContactsMenuItemClickedAction'
);

export const deletePersonasClicked = (dispatch: Dispatch) => () =>
    dispatch(deletePersonasClickedAction());
export const contactCleanupMenuItemClicked = (dispatch: Dispatch) => () =>
    dispatch(contactCleanupMenuItemClickedAction());
export const exportContactsMenuItemClicked = (dispatch: Dispatch) => () =>
    dispatch(exportContactsMenuItemClickedAction());
export const importContactsMenuItemClicked = (dispatch: Dispatch) => () =>
    dispatch(importContactsMenuItemClickedAction());

export const enableCAPIv3ToggledAction = createActionFactory<{
    isEnabled: boolean;
}>('EnableCAPIv3ToggledAction', Feature.Navigation);

export const enableCAPIv3Toggled = (isEnabled: boolean) =>
    createThunk('EnableCAPIv3ToggledAction', (dispatch: ThunkDispatch, getState: () => {}) => {
        dispatch(enableCAPIv3ToggledAction({ isEnabled }));
        dispatch(serializeAndPersistPeopleHubOptions)();
        const appState = getAppState(getState());
        const favoritePersonasCount =
            appState.data.hubState.favoritePersonsState.favoritePersons.length;

        // Programatically invoke click action to update the hublist with contacts
        // from CAPIv2/CAPIv3 based on toggle value or go to the favorites tab
        dispatch(
            menuItemClicked(favoritePersonasCount ? favoritesLeftNavItemId : contactsLeftNavItemId)
        );
    });
export type { Action } from '../../../shared';
